import Alpine from 'alpinejs';
import H5PBlanks from './h5p/types/H5P.Blanks.js';
import H5PDragText from './h5p/types/H5P.DragText.js';
import H5PEssay from './h5p/types/H5P.Essay.js';
import H5PMultiChoice from './h5p/types/H5P.MultiChoice.js';
import H5PDragQuestion from "./h5p/types/H5P.DragQuestion.js";
import H5PTrueFalse from './h5p/types/H5P.TrueFalse.js';

import '../styles/results.css';

window.Alpine = Alpine;

window.drillDown = (url) => {
	return {
		attempts: [],
		type: null,
		currentActivity: null,
		currentStudent: null,
		preview: false,
		selectedAttemptIndex: null,
		url,
		openModal({blogId, postId, activity, student}) {
			this.reset();

			const [url, defaultParams] = this.url.split('?');

			this.currentActivity = activity;
			this.currentStudent = student;

			const params = new URLSearchParams(defaultParams);

			params.set('user_id', student.id);
			params.set('blog_id', blogId);
			params.set('post_id', postId);
			params.set('h5p_id', activity.id);

			fetch(`${url}?${params}`, {
				headers: {
					'Content-Type': 'application/json',
				}
			})
				.then(response => response.json())
				.then(({h5p_attempts, h5p_type, parameters}) => {
					this.attempts = h5p_attempts;
					this.type = h5p_type;
					this.selectedAttemptIndex = 0;
					this.parameters = parameters;
				})
				.catch(console.log);

			this.$refs.modal.showModal();
		},
		closeModal() {
			this.reset();

			this.$refs.modal.close();
		},
		openPreview() {
			this.preview = ! this.preview;

			if (! this.preview) {
				return;
			}

			this.$nextTick(() => {
				const iframe = document.querySelector('iframe[data-drill-down-activity-preview]');

				setTimeout(() => {
					const document = iframe.contentWindow.document;
					// Resize H5P activities to fit the content
					if (iframe.contentWindow.H5P && iframe.contentWindow.H5P.instances) {
						iframe.contentWindow.H5P.instances.forEach(function(instance) {
							if (instance.trigger) {
								instance.trigger('resize');
							}
						});
					}

					const activity = document.querySelector('.h5p-content');

					iframe.style.height = `${activity.scrollHeight}px`;
				}, 100);
			});
		},
		showAttemptData(index) {
			this.selectedAttemptIndex = index;
		},
		formatOption(attempt) {
			if (!attempt) {
				return '';
			}

			const date = new Intl.DateTimeFormat('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				hour: 'numeric',
				minute: '2-digit',
				hour12: true
			}).format(new Date(attempt.created_at));

			return `${date} (grade: ${attempt.score})`;
		},
		renderActivity() {
			if (! this.type || this.selectedAttemptIndex === null) {
				return '';
			}

			const attempt = this.attempts[this.selectedAttemptIndex];
			const parameters = this.parameters || {};

			const strategies = {
				'H5P.Blanks': () => H5PBlanks(attempt, parameters),
				'H5P.DragText': () => H5PDragText(attempt, parameters),
				'H5P.Essay': () => H5PEssay(attempt, parameters),
				'H5P.MultiChoice': () => H5PMultiChoice(attempt, parameters),
				'H5P.DragQuestion' : () => H5PDragQuestion(attempt, parameters),
				'H5P.TrueFalse': () => H5PTrueFalse(attempt),
				'default': () => `<p>No visualization available for this activity</p>`,
			};

			return (strategies[this.type || 'default'] || strategies.default)();
		},
		reset () {
			this.attempts = [];
			this.currentActivity = null;
			this.currentStudent = null;
			this.preview = false;
			this.type = null;
			this.parameters = {};
		}
	}
}

Alpine.start();

window.addEventListener('beforeunload', function () {
	document.getElementById('loading-indicator').style.display = 'flex';
});

window.addEventListener('load', function () {
	document.getElementById('loading-indicator').style.display = 'none';

	const trigger = document.querySelector('.grading-scheme button');
	const popover = document.querySelector('.grading-scheme [popover]');

	function positionPopover() {
		const triggerRect = trigger.getBoundingClientRect();
		const windowWidth = document.documentElement.clientWidth;

		popover.style.top = `${triggerRect.y + triggerRect.height + window.scrollY}px`;

		if (triggerRect.x + window.scrollX + 200 >= windowWidth) {
			popover.style.left = `${windowWidth - window.scrollX - 150}px`;
		} else {
			popover.style.left = `${triggerRect.x + window.scrollX}px`;
		}
	}

	positionPopover();

	window.addEventListener('resize', positionPopover);
});
